import { render, staticRenderFns } from "./page.slot.vue?vue&type=template&id=892f47be&"
import script from "./page.slot.vue?vue&type=script&lang=js&"
export * from "./page.slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports